import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/MainPage'
import CoordPage from '@/components/CoordPage'

Vue.use(Router)

export default new Router({
  routes: [
     {
      path: '/nmeatranslator',
      name: 'NmeaTranslator',
      component: MainPage
    },
    {
        path: '/coordinates',
        name: 'Coordinates',
        component: CoordPage
      }
  ]
})
